import EpidemicData from "../../data/epidemic.data";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  logo: {
    width: 84,
    height: 70,
    marginLeft: "auto",
    marginRight: "auto",
  },
  titleContainer: {
    marginTop: 24,
  },
  reportTitle: {
    color: "#3778C2",
    letterSpacing: 4,
    fontSize: 25,
    textAlign: "center",
    textTransform: "uppercase",
  },
  reportDescription: {
    fontSize: 12,
    marginBottom: 10,
  },
  row: {
    flexDirection: "column",
    borderBottomWidth: 1,
    fontSize: 12,
    fontStyle: "bold",
  },
  description: {
    width: "100%",
  },
  total: {
    width: "100%",
  },
});

export type updateEpidemicTypes = {
  formData: {
    eventDate: string;
    illness: string;
    numberOfChildren: string;
    numberOfTeacher: string;
    actionTaken: string;
    printeventDate?: boolean;
    printillness: string;
    printnumberOfChildren: string;
    printnumberOfTeacher: string;
    printactionTaken: string;
  };
};

export const EpidemicPdf = ({ formData }: updateEpidemicTypes) => {
  const { t } = useTranslation();
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.titleContainer}>
          <Text style={styles.reportTitle}>{t(EpidemicData.title)}</Text>
          <Text style={styles.reportDescription}>
            {t(EpidemicData.description.i18nKey)}
          </Text>
        </View>
        {EpidemicData.fields.map((field, index) => {
          if (field.name === "eventDate" && formData["printeventDate"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.name)}</Text>
                <Text style={styles.description}>
                  {t(formData["eventDate"])}
                </Text>
              </View>
            );
          } else if (field.name === "illness" && formData["printillness"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.name)}</Text>
                <Text style={styles.description}>{t(formData["illness"])}</Text>
              </View>
            );
          } else if (
            field.name === "numberOfChildren" &&
            formData["printnumberOfChildren"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {formData["numberOfChildren"]}
                </Text>
              </View>
            );
          } else if (
            field.name === "numberOfTeacher" &&
            formData["printnumberOfTeacher"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {formData["numberOfTeacher"]}
                </Text>
              </View>
            );
          } else if (
            field.name === "actionTaken" &&
            formData["printactionTaken"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {formData["actionTaken"]}
                </Text>
              </View>
            );
          }
          return null;
        })}
      </Page>
    </Document>
  );
};
